export default __webpack_public_path__ + "static/media/logo-decada-ciencia-oceanica-br.c955aa46.png";